import React from 'react';

import { AlertTriangle } from 'react-feather';
import { useIntl } from 'react-intl';

import { Spinner } from 'components';

import messages from '../messages';
import styles from '../States.module.scss';

const ErrorScreen = ({ error, renderIcon, refreshing, onRefresh }) => {
  const intl = useIntl();

  return (
    <div className={styles.wrap}>
      {renderIcon ? renderIcon(40, '#e53935') : <AlertTriangle className={`${styles.icon} ${styles.iconError}`} size={40} />}
      <p className={styles.text}>{intl.formatMessage(messages.errorMessage, { error })}</p>
      {onRefresh && (
        <button type="button" className={styles.retryBtn} onClick={onRefresh} disabled={refreshing}>
          {refreshing ? <Spinner show size="sm" /> : 'Try again'}
        </button>
      )}
    </div>
  );
};

export default ErrorScreen;
